let script;

// NOTE: List of pages where loader should not be display
// specially when files need to be loader

const pagesNoLoader = ['account/invoice', 'account/orders'];
// TODO : ERROR leyendo
// $(window)
//   .on('beforeunload', function(event){
//     // let displayLoader = pagesNoLoader.filter(( item ) => {
//     //   item.
//     // })
//     if ( document.activeElement ) {
//       if (document.activeElement.href){
//         if  ( document.activeElement.href.indexOf('download') != -1) {
//           return ;
//         }
//       }
//     }
//       $('.modal').modal('hide');
//       document.querySelector('.main-loader').classList.remove('d-none');
//       $('main, footer').animate({
//         opacity: 0,
//       }, 300);
// });

$(document).ready(function () {
  $('body').on('click', '.aa-ItemContent', function () {
    const searchTranslate = $('.btn-search-product').attr('data-href');
    alert('alert 3');
    setTimeout(function () {
      window.location.href =
        '/' + locale + '/' + searchTranslate + '?query=' + encodeURI($('#autocomplete-0-input').val());
    }, 500);
  });

  $('#filters').on('show.bs.collapse', function () {
    $('.dark-screen').removeClass('d-none');
    $('body').addClass('fixedPosition');
    $('.section-algolia-faceting').addClass('d-none');
  });

  $('#filters').on('hidden.bs.collapse', function () {
    console.log('entro close ');
    $('.dark-screen').addClass('d-none');
    $('body').removeClass('fixedPosition');
    $('.section-algolia-faceting').removeClass('d-none');
  });

  $('body').on('keydown', '.sk-search-box__text', function (e) {
    if (e.keyCode == 13) {
      window.location.href = translate('searchPage') + '?query=' + encodeURI($(this).val());
      return false;
    }
  });

  validateFormCheck('form[name="account_register"]', 'input[id="terms_cgv"]', '.cgv-maessage');
  validateFormCheck('form[name="guest_create"]', 'input[id="terms_cgv"]', '.cgv-maessage');
  toggleClassOnCheck('input#terms_cgv', '.cgv-maessage');

  $('[data-toggle=nav-sm-display]').click(function () {
    $($(this).data('target')).toggleClass('open-nav');
  });

  if ($('[data-enable-owl]').length > 0) {
    initOWL();
  }
  /**
  DOC: Toggle show more and show less for the preview block text
  * The preview block text needs to hava the class 'target-text'
  * Required for:
    - block_text section
    - algolia_faceting section
 */
  $('body').on('click', '.show-more-btn', function () {
    $(this).prev().toggleClass($(this).prev().data('ellipsed'));
    $(this).toggleClass('is-ellipsed is-expanded');
  });

  $('.carousel-multi-item').on('slide.bs.carousel', function (e) {
    var $e = $(e.relatedTarget);
    var idx = $e.index();
    var itemsPerSlide = 4;
    var totalItems = $('.carousel-item').length;

    if (idx >= totalItems - (itemsPerSlide - 1)) {
      var it = itemsPerSlide - (totalItems - idx);
      for (var i = 0; i < it; i++) {
        // append slides to end
        if (e.direction == 'left') {
          $('.carousel-item').eq(i).appendTo('.carousel-inner');
        } else {
          $('.carousel-item').eq(0).appendTo('.carousel-inner');
        }
      }
    }
  });
  $(document).on('ShopinvaderForm:after-error', function (element) {
    document.querySelector('.main-loader').classList.add('d-none'); // DISPLAY LOADING
    $('#generic-error-message').toast('show');
  });

  $(document).on('ShopinvaderForm:before-submit', function (event, element) {
    document.querySelector('.main-loader').classList.remove('d-none');
  });

  $(document).on('ShopinvaderForm:after-submit', function (event, element) {
    document.querySelector('.main-loader').classList.add('d-none'); // DISPLAY LOADING
    $('main, footer').animate(
      {
        opacity: 1
      },
      300
    );

    if ($(element.target).attr('action') == '/invader/cart/add_item') {
      $.notify($(element.target).attr('swal-message'), {
        showDuration: 300,
        clickToHide: true,
        // whether to auto-hide the notification
        autoHide: true,
        // if autoHide, hide after milliseconds
        autoHideDelay: 3000,
        className: 'success'
      });

      //change sessions
      const productCategoryId = parseInt($(element.target).attr('data-category-id'));
      if (window.giftBasketCategories.includes(productCategoryId)) {
        localStorage.setItem('giftBasketHasCart', JSON.stringify(true));
        localStorage.setItem('restaurantHasCart', JSON.stringify(false));
      } else {
        localStorage.setItem('giftBasketHasCart', JSON.stringify(false));
        localStorage.setItem('restaurantHasCart', JSON.stringify(true));
      }
    }

    if ($(element.target).attr('action') == '/invader/cart/delete_item') {
      const cartSize = parseInt(document.getElementById('shoping-cart').dataset.cartSize.trim());
      if (cartSize == 0) {
        localStorage.setItem('giftBasketHasCart', JSON.stringify(false));
        localStorage.setItem('restaurantHasCart', JSON.stringify(false));
      }
    }
  });

  $('body').on('click', '.cart-items .delete', function () {
    $('form#' + $(this).data('form-submit')).submit();
  });

  $('body').on('change', '[data-autosubmit]', function () {
    $(this).parents('form').submit();
  });
  $('[data-toggle=display-hover]').hover(
    function () {
      $($(this).attr('data-target')).css('display', 'block');
    },
    function () {
      $($(this).attr('data-target')).css('display', 'none');
    }
  );

  $('.nav-header-controls-item').hover(
    function () {
      $('.nav-header-controls .header-controls-dropdown-content').hide();
      $(this).find('.header-controls-dropdown-content').slideDown(200);
    },
    function () {
      $(this).find('.header-controls-dropdown-content').delay('1500').slideUp(100);
    }
  );

  $('body').on('change', '.product-qty input', function (event) {
    var max_value = 100;
    var min_value = 1;
    /*Set custom max value*/
    if ($(this).attr('max')) {
      max_value = $(this).attr('max');
    }
    /*Set custom min value*/
    if ($(this).attr('min')) {
      min_value = $(this).attr('min');
    }
    var current_value = parseInt($(this).val());

    if (current_value > max_value) {
      current_value = max_value;
    }
    if (current_value < min_value) {
      current_value = min_value;
    }
    if (isNaN(current_value)) {
      current_value = min_value;
    }
    $(this).val(current_value);
    if ($(this).parents('.cart-line-qty').length > 0) {
      /*Input in cart lines*/
      $(this).parents('form').submit();
    }
  });
  $('body').on('click', '.product-qty [data-type]', function (event) {
    var input_qty = $(event.currentTarget).parent('.input-group').find('input.form-control');

    if (input_qty.length > 0) {
      var qty = input_qty.val();
      if ($(this).attr('data-type') == 'minus') {
        qty--;
        if (qty < 1) {
          qty = 1;
        }
      } else {
        qty++;
      }
      input_qty.val(qty);
      input_qty.trigger('change');
    }
  });

  // $('body').on('submit', '#cart_address', function (event) {
  //   event.preventDefault();
  //   if ($(this).find('#use_specific_address:checked').length == 0) {
  //     var shipping_addresss_id = $('input.input-shipping-address:checked').val();
  //     $('input.input-invoicing-address[value=' + shipping_addresss_id + ']').prop('checked', true);
  //   }
  //   $(this).get(0).submit();
  // });

  /*common event*/
  $('body').on('click', '[data-link]', function () {
    window.location = $(this).attr('data-link');
  });

  // $('body').on('click', '[data-scrollto]',
  //   function () {
  //     $('html, body').animate({
  //       scrollTop: $($(this).data('scrollto')).offset().top - $('.navbar-fixed-top').height()
  //     }, 1500);
  //   }
  // );

  $('body').on('click', '[data-gourmet-link]', async function () {
    const gourmetId = $(this).attr('data-gourmet-id');
    switch (gourmetId) {
      case 'restaurant':
        if (localStorage.getItem('giftBasketHasCart') == 'true') {
          await handleSessionAddToCart(null, pretAMangerUrl);
        } else {
          localStorage.setItem('isGiftBasketSession', JSON.stringify(false));
          localStorage.setItem('giftBasketHasCart', JSON.stringify(false));
          window.location.href = pretAMangerUrl;
        }
        break;
      case 'gift-basket':
        if (localStorage.getItem('restaurantHasCart') == 'true') {
          await handleSessionAddToCart(null, giftBasketUrl);
        } else {
          localStorage.setItem('isGiftBasketSession', JSON.stringify(true));
          localStorage.setItem('restaurantHasCart', JSON.stringify(false));
          window.location.href = giftBasketUrl;
        }
        break;
      default:
        break;
    }
  });
});

var main_modal = {
  id: 'main-modal',
  show: function (title, body, footer, wholeHeight = false) {
    $('#' + main_modal.id + ' .modal-body').html(body);
    if (typeof footer != 'undefined' && footer.length > 0) {
      $('#' + main_modal.id + ' .modal-footer').html(footer);
      $('#' + main_modal.id + ' .modal-footer').removeClass('d-none');
    }
    $('#' + main_modal.id + ' .modal-title').html(title);
    $('#' + main_modal.id).modal('show');

    if (wholeHeight) {
      $('#' + main_modal.id + ' .modal-content').addClass('h-100 border-0 bg-light-50');
      $('#' + main_modal.id + ' .modal-footer').addClass('border-0');
    }
  },
  close: function () {
    $('#' + main_modal.id).modal('hide');
  },
  clear: function () {
    $('#' + main_modal.id + ' .modal-body').html('');
    $('#' + main_modal.id + ' .modal-footer').html('');
    $('#' + main_modal.id + ' .modal-title').html('');
  }
};

function contact_recaptcha(event) {
  $('.form-contact [type=submit]').attr('disabled', false);
}

const handleSessionAddToCart = async function (form = null, anchor = null) {
  const giftBasketHasCart = JSON.parse(localStorage.getItem('giftBasketHasCart'));
  const restaurantHasCart = JSON.parse(localStorage.getItem('restaurantHasCart'));

  if (document.querySelector('#mobile-sitenav')) {
    closeNav();
  }
  const cartProducts = giftBasketHasCart
    ? window.translate('cta_gift_basket')
    : restaurantHasCart
    ? window.translate('cta_take_away')
    : 'Gourmet';
  const previousCartProducts = giftBasketHasCart
    ? window.translate('cta_take_away')
    : restaurantHasCart
    ? window.translate('cta_gift_basket')
    : 'Gourmet';
  Swal.fire({
    title: window?.translate('alert')?.replace(':', '').trim(),
    html: window.dynamicTranslation('cart_alert_message', '$__', cartProducts),
    icon: 'warning',
    showDenyButton: true,
    showCancelButton: false,
    showCloseButton: true,
    denyButtonColor: '#2E4200',
    confirmButtonColor: '#e10915',
    confirmButtonText: window.dynamicTranslation('cart_alert_confirm', '$__', previousCartProducts),
    denyButtonText: window.translate('cart_checkout')
  }).then(async (result) => {
    if (result.isConfirmed) {
      const cartClear = await clearCart();

      if (cartClear.ok) {
        localStorage.setItem('giftBasketHasCart', JSON.stringify(false));
        localStorage.setItem('restaurantHasCart', JSON.stringify(false));
        if (form) {
          form.submit();
        } else if (anchor) {
          window.location.href = anchor;
        }
      }
    } else if (result.isDenied) {
      window.location = cartUrl;
    }
  });
};
window.handleSessionAddToCart = handleSessionAddToCart;
var dropdown = document.getElementsByClassName('dropdown-btn');
var i;
for (i = 0; i < dropdown.length; i++) {
  dropdown[i].addEventListener('click', function () {
    this.classList.toggle('active');
    var dropdownContent = this.nextElementSibling;
    if (dropdownContent.style.display === 'block') {
      dropdownContent.style.display = 'none';
      this.getElementsByClassName('drop-icon')[0].classList.remove('fa-minus');
      this.getElementsByClassName('drop-icon')[0].classList.add('fa-plus');
    } else {
      dropdownContent.style.display = 'block';
      this.getElementsByClassName('drop-icon')[0].classList.remove('fa-plus');
      this.getElementsByClassName('drop-icon')[0].classList.add('fa-minus');
    }
  });
}

if (document.getElementById('go-back')) {
  document.getElementById('go-back').addEventListener('click', () => {
    history.back();
  });
}

if (document.querySelector('.see-filter-results')) {
  document.querySelector('.see-filter-results').addEventListener('click', closeFilter);
}

$('<span toggle="#auth-password" class="fal fa-fw fa-eye-slash field-icon toggle-password"></span>').insertAfter(
  'input[type="password"]'
);
//toggle password visibility
$('.toggle-password').click(function () {
  $(this).toggleClass('fa-eye-slash fa-eye');
  var input = $(this).prev('input');
  if (input.attr('type') == 'password') {
    input.attr('type', 'text');
  } else {
    input.attr('type', 'password');
  }
});

function validateFormCheck(form, elementTocheck, messageContainer) {
  if ($(form).length > 0) {
    $(form).submit(function (e) {
      if ($(elementTocheck).prop('checked') == false) {
        $(messageContainer).removeClass('d-none');
        e.preventDefault();

        return false;
      } else {
        $(messageContainer).addClass('d-none');
        return true;
      }
    });
  }
}

function toggleClassOnCheck(element, messageContainer) {
  $('body').on('click', element, function () {
    if ($(this).prop('checked')) {
      $(messageContainer).addClass('d-none');
    } else {
      $(messageContainer).removeClass('d-none');
    }
  });
}

function cartUpdate(data) {
  fetch('/invader/cart/update', {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify(data)
  })
    .then(function (res) {
      console.log(res);
    })
    .catch(function (res) {
      console.log(res);
    });
}

async function clearCart() {
  try {
    document.querySelector('.main-loader').classList.remove('d-none'); // Show loader
    const res = await fetch('/invader/cart/clear', {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: '{}'
    });
    const data = await res.json();
    console.log('clear cart response', data);
    return { ok: res.ok, data };
  } catch (error) {
    console.log('clear cart error', error);
    return { ok: false, error };
  } finally {
    document.querySelector('.main-loader').classList.add('d-none'); // Hide loader
  }
}

function deleteItem(id) {
  var data = {
    item_id: id
  };
  cartUpdate(data);
}
function updateCart(addressid) {
  var data = {
    shipping: {
      address: {
        id: addressid
      }
    }
  };

  updateCart(data);
}

function fetchOnClick(element) {
  updateCart($(element).val());
  $('body').on('click', element, function () {
    if ($(this).prop('checked')) {
      updateCart($(this).val());
    } else {
      $('#modal-address-invoicing').modal('show');
    }
  });
}
document.addEventListener('DOMContentLoaded', function (e) {
  const cartSize = parseInt(document.getElementById('shoping-cart').dataset.cartSize.trim());
  if (cartSize > 0) {
    const cartFirstProductCategory =
      parseInt(document.getElementById('cart-products-category').dataset.category.trim()) || 0;

    if (window.giftBasketCategories.includes(cartFirstProductCategory)) {
      localStorage.setItem('giftBasketHasCart', JSON.stringify(true));
      localStorage.setItem('restaurantHasCart', JSON.stringify(false));
      const giftBasketLinks = document.querySelectorAll('[data-gourmet-id="gift-basket"]');
      giftBasketLinks.forEach((link) => link.classList.add('active-session'));
    } else {
      localStorage.setItem('giftBasketHasCart', JSON.stringify(false));
      localStorage.setItem('restaurantHasCart', JSON.stringify(true));
      const takeAwayLinks = document.querySelectorAll('[data-gourmet-id="restaurant"]');
      takeAwayLinks.forEach((link) => link.classList.add('active-session'));
    }
  } else {
    localStorage.setItem('giftBasketHasCart', JSON.stringify(false));
    localStorage.setItem('restaurantHasCart', JSON.stringify(false));
  }

  if ('loading' in HTMLImageElement.prototype) {
    // Si el navegador soporta lazy-load, tomamos todas las imágenes que tienen la clase
    // `lazyload`, obtenemos el valor de su atributo `data-src` y lo inyectamos en el `src`.
    const images = document.querySelectorAll('img.lazyload');
    images.forEach((img) => {
      img.src = img.dataset.src;
    });
  } else {
    // Importamos dinámicamente la libreria `lazysizes`
    let script = document.createElement('script');
    script.async = true;
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.2.0/lazysizes.min.js';
    document.body.appendChild(script);
  }

  if (window.location.hash) {
    setTimeout(function () {
      if ($(window.location.hash).length > 0) {
        const element = $(window.location.hash);
        scrollToHash(element);
      }
    }, 1);
  }

  initMenu();

  const inputSubmit = $('#cart_carrier_form').find('input[data-autosubmit]:checked');

  if (inputSubmit.attr('checked') === 'checked') {
    $(this).parent('form').submit();
  }
});

window.initMenu = function () {
  // window.addEventListener('scroll', function () {
  //   if (window.scrollY > 50) {
  //     //document.getElementById('main-header').classList.add('fixed-top');
  //     if (document.getElementById('product-info'))
  //       document.getElementById('product-info').classList.add('fixed-div');
  //     // add padding top to show content behind navbar
  //     navbar_height = document.querySelector('.navbar').offsetHeight;
  //   } else {
  //     //document.getElementById('main-header').classList.remove('fixed-top');
  //     if (document.getElementById('product-info')) {
  //       document.getElementById('product-info').classList.remove('fixed-div');
  //     }
  //     // remove padding top from body
  //     document.body.style.paddingTop = '0';
  //   }
  // });
};

window.isMobile = isMobile();

function isMobile() {
  // credit to Timothy Huang for this regex test:
  // https://dev.to/timhuang/a-simple-way-to-detect-if-browser-is-on-a-mobile-device-with-javascript-44j3
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true;
  } else {
    return false;
  }
}

window.addScript = function (filename, callback) {
  var body = document.getElementsByTagName('body')[0];

  script = document.createElement('script');
  script.src = filename;
  script.type = 'text/javascript';

  body.append(script);
  script.onreadystatechange = script.onload = callback;
};

function initOWL() {
  let mobile = isMobile();

  $('[data-enable-owl]').each(function () {
    const $this = $(this);
    let items_0 = parseInt($this.attr('mobile-items'));
    let items_1000 = parseInt($this.attr('desktop-items'));
    let totalSize = 0;
    let isOwlable = (!mobile && items_1000 > 0) || (mobile && items_0 > 0);
    if ($this.attr('data-size')) {
      totalSize = parseInt($this.attr('data-size'));
      isOwlable = (!mobile && totalSize > items_1000) || (mobile && totalSize > items_0);
    }

    if (isOwlable) {
      $this.owlCarousel({
        onInitialize: function () {
          $('<div class="dots-1"></div>').insertBefore($this);
        },
        onInitialized: function () {
          setTimeout(function () {
            $this.prev().addClass('d-none');
            $this.removeClass('c-invisible');
          }, 1500);
        },
        margin: 10,
        nav: true,
        dots: false,
        responsive: {
          0: {
            items: items_0
          },
          600: {
            items: 2
          },
          1000: {
            items: items_1000
          }
        }
      });
    } else {
      $this.removeClass('owl-carousel owl-theme c-invisible');
      $this.addClass('d-flex justify-content-center justify-image');
    }
    // $this.removeClass('c-invisible');
  });
}

function addCSS(filename) {
  var head = document.getElementsByTagName('head')[0];

  var style = document.createElement('link');
  style.href = filename;
  style.type = 'text/css';
  style.rel = 'stylesheet';
  head.append(style);
}

window.scrollToHash = function (target) {
  var headerHeight;
  if (isMobile()) {
    headerHeight = 110;
    if ($('#header-search-hit-header')) {
      headerHeight += $('#main-header').height() - 40;
    }
  } else {
    headerHeight = 230;
  }

  $('html, body').animate({ scrollTop: target.offset().top - headerHeight }, 1, 'linear');
};

window.getUrlParam = function (paramName) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(paramName);
};

window.tawkPopup = function () {
  try {
    Tawk_API = Tawk_API || {};
    Tawk_API.popup();
    Tawk_API.hideWidget();

    Tawk_API.onChatEnded = function () {
      Tawk_API.minimize();
    };
  } catch (error) {
    console.log('Couldn´t destroy tawk', error);
  }
};

window.fillUpModal = function (params) {
  let modalHolder = document.querySelector('#userModal');
  if (typeof params == 'object') {
    modalHolder.querySelector('.custom-modal-title').innerHTML = params.title;
    modalHolder.querySelector('.custom-modal-body').innerHTML = params.body;
    modalHolder.querySelector('.custom-modal-footer').innerHTML = params.footer;
  } else {
    throw 'Error en los parámetros';
  }
};

function findClosestParent(startElement, fn) {
  var parent = startElement.parentElement;
  if (!parent) {
    return undefined;
  }
  return fn(parent) ? parent : findClosestParent(parent, fn);
}

window.collapseAction = function (el) {
  return {
    hide: function () {
      $(el).collapse('hide');
    },
    show: function () {
      $(el).collapse('show');
    },
    toggle: function () {
      $(el).collapse('toggle');
    }
  };
};

/* Defer parsing of JS YouTube (ayudawp.com) */
function deferedInit() {
  var vidDefer = document.getElementsByTagName('iframe');
  for (var i = 0; i < vidDefer.length; i++) {
    if (vidDefer[i].getAttribute('data-src')) {
      vidDefer[i].setAttribute('src', vidDefer[i].getAttribute('data-src'));
    }
  }
}
window.onload = deferedInit;

if (typeof document.querySelector('.countries') != 'undefined' && document.querySelector('.countries') != null) {
  const countriesBox = document.querySelector('.countries');
  handleStatesDropdown();
  countriesBox.addEventListener('change', handleStatesDropdown);
}

function handleStatesDropdown() {
  const countryElement = document.querySelector('.countries');
  const selValue = countryElement.value;
  const currentState = parseInt(countryElement.dataset.stateId);
  const statesSelectBox = document.querySelector('.states-dropdown');
  const stateParent = document.getElementById('states');
  const country = window.available_countries.find((ctr) => ctr.id === parseInt(selValue));

  //first empty the state options
  statesSelectBox.innerHTML = '';
  stateParent.classList.add('d-none');

  if (country.states && country.states.length > 0) {
    /* const realStates = country.states.filter(function (el) {
        return Number.isInteger(parseInt(el.code));
      }); */

    country.states.forEach((state) => {
      let stateOptions = document.createElement('option');
      const optionText = document.createTextNode(capitalize(state.name));
      stateOptions.appendChild(optionText);
      stateOptions.setAttribute('value', parseInt(state.id));

      if (state.id === currentState) {
        stateOptions.setAttribute('selected', 'selected');
      }

      statesSelectBox.appendChild(stateOptions);
    });

    stateParent.classList.remove('d-none');
  } else {
    stateParent.classList.add('d-none');
    statesSelectBox.innerHTML = '';
  }
}

window.isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

window.toggleBlockView = function (target, classToToggle) {
  var targetElement = document.querySelector(target);
  targetElement.classList.toggle(classToToggle);
  if (target === '.search-block') {
    document.getElementById('autocomplete-search').focus();
  }
};

window.copyToClipboard = function (element) {
  var $temp = $('<input>');
  $('body').append($temp);
  $temp.val($(element).text()).select();
  document.execCommand('copy');
  $temp.remove();
};

window.onpopstate = function () {
  location.reload();
};

function dmyToMdy(strDate) {
  return swapArrayFirstElements(strDate.split('/')).join('/');
}

function swapArrayFirstElements(array) {
  return [array[1], array[0], ...array.slice(2)];
}

function padTo2Digits(num) {
  return num.toString().padStart(2, '0');
}

function formateDate(date) {
  return [padTo2Digits(date.getDate()), padTo2Digits(date.getMonth() + 1), date.getFullYear()].join('/');
}

function isPastDate(date) {
  return new Date(dmyToMdy(date)) < new Date(dmyToMdy(formateDate(new Date())));
}

window.isPastDate = isPastDate;


window.convertUTCToLocal = function (utcDate, timeZone = "Europe/Madrid") {
  !utcDate.endsWith('Z') && (utcDate += 'Z');
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).format(new Date(utcDate));
}